import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./Zmluvy.scss";

// proptypes
import odberatelPropTypes from "../../propTypes/odberatelPropTypes";
import zmluvyPropTypes from "../../propTypes/zmluvyPropTypes";

// components
import Grid from "../../zisComponents/grid/Grid";
import ErrorMsg from "../ErrorMsg";

// actions
import * as appHeaderActions from "../../actions/appHeaderActions";
import * as zmluvyActions from "../../actions/zmluvy/zmluvyActions";

class Zmluvy extends React.Component {
  constructor(props) {
    super(props);

    this.gridFilter = { filters: [] };
    this.gridSort = [];
    this.gridPage = { skip: 0, take: 10 };
  }

  // GRID PROPS
  genGridSchema = () => {
    return [
      { field: "C_ZMLUVY", title: "Číslo zmluvy", width: "auto" },
      { field: "LIST_OM", title: "Odberné miesta", width: "auto" },
      { field: "D_UCINNOSTI", title: "Dátum účinnosti", filter: "date", width: "auto", format: "{0:dd.MM.yyyy}" },
    ];
  };
  genGridDetailSchema = () => {
    return [
      { field: "N_UHRADA", title: "Úhrada" },
      { field: "IBAN", title: "IBAN" },
    ];
  };
  onChangeHandle = (filter, sort, page) => {
    this.gridFilter = filter;
    this.gridSort = sort;
    this.gridPage = page;
  };
  onRowDoubleClickHandle = async (event) => {
    const data = this.buildChangeZmluvaData(event.dataItem);
    await this.props.changeZmluva(data, true);
  };
  getListZmluvaHandle = async () => {
    const { customFilters, getListZmluva } = this.props;
    const { gridFilter, gridSort, gridPage } = this;

    await getListZmluva(gridFilter, gridSort, gridPage, customFilters);
  };

  // METHODS
  buildGridsProps = () => {
    const {
      gridFilterOM,
      gridPageOM,
      gridSortOM,

      gridFilterFaktura,
      gridSortFaktura,
      gridPageFaktura,
    } = this.props;

    return {
      OM: {
        gridFilter: gridFilterOM,
        gridSort: gridSortOM,
        gridPage: gridPageOM,
      },
      faktury: {
        gridFilter: gridFilterFaktura,
        gridSort: gridSortFaktura,
        gridPage: gridPageFaktura,
      },
    };
  };
  buildChangeZmluvaData = (zmluva) => {
    const grids = this.buildGridsProps();

    return {
      zmluva,
      grids,
    };
  };

  // SYSTEM METHODS
  componentDidMount = async () => {
    const { showAppHeader, changeHeaderTitle } = this.props;

    showAppHeader(true);
    changeHeaderTitle("Zmluvy");
  };
  render() {
    const {
      isOdberatelPicked,
      zmluva,
      listZmluva,
      isLoading,
      total,
      isZmluvaPickedByDoubleClickInGridRow,
    } = this.props;

    return (
      <div className="row m-0 component">
        <div className="col p-0">
          <Grid
            className={isOdberatelPicked ? "" : "hidden"}
            data={
              isZmluvaPickedByDoubleClickInGridRow ? [zmluva] : listZmluva
            }
            detailSchema={this.genGridDetailSchema()}
            isLoading={isLoading}
            onChange={this.onChangeHandle}
            onGet={() => { }}
            onGetList={this.getListZmluvaHandle}
            onRowDoubleClick={this.onRowDoubleClickHandle}
            primaryField="I_ZMLUVY"
            schema={this.genGridSchema()}
            total={isZmluvaPickedByDoubleClickInGridRow ? 1 : total}
          />
          {!isOdberatelPicked && <ErrorMsg text="Vyberte odberateľa" />}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    // list zmluva
    customFilters: state.listZmluva.customFilters,
    isLoading: state.listZmluva.isLoading,
    listZmluva: state.listZmluva.data,
    total: state.listZmluva.total,

    // zmluva
    isZmluvaPickedByDoubleClickInGridRow:
      state.zmluva.isPickedByDoubleClickInGridRow,
    zmluva: state.zmluva.data,

    // ODBERATEL
    isOdberatelPicked: state.odberatel.isPicked,
    odberatel: state.odberatel.data,

    // OM GRID
    gridFilterOM: state.listOM.gridFilter,
    gridSortOM: state.listOM.gridSort,
    gridPageOM: state.listOM.gridPage,

    // FAKTURY GRID
    gridFilterFaktura: state.listFaktura.gridFilter,
    gridSortFaktura: state.listFaktura.gridSort,
    gridPageFaktura: state.listFaktura.gridPage,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getListZmluva: async (gridFilter, gridSort, gridPage, customFilters) =>
    await dispatch(
      zmluvyActions.getListZmluva({
        gridFilter,
        gridSort,
        gridPage,
        customFilters,
      })
    ),
  changeHeaderTitle: (title) =>
    dispatch(appHeaderActions.changeHeaderTitle(title)),
  changeZmluva: (data, gridRowDoubleClicked = false) =>
    dispatch(zmluvyActions.changeZmluva(data, gridRowDoubleClicked)),
  showAppHeader: (show) => dispatch(appHeaderActions.showAppHeader(show)),
});

Zmluvy.propTypes = {
  customFilters: PropTypes.arrayOf(PropTypes.object),
  getListZmluva: PropTypes.func,
  changeHeaderTitle: PropTypes.func,
  changeZmluva: PropTypes.func,
  isLoading: PropTypes.bool,
  isOdberatelPicked: PropTypes.bool,
  isZmluvaPickedByDoubleClickInGridRow: PropTypes.bool,
  listZmluva: PropTypes.arrayOf(zmluvyPropTypes.zmluva),
  odberatel: odberatelPropTypes.odberatel,
  showAppHeader: PropTypes.func,
  total: PropTypes.number,
  zmluva: zmluvyPropTypes.zmluva,
};

export default connect(mapStateToProps, mapDispatchToProps)(Zmluvy);
